export default {"src":"/_next/static/media/palm_64.947ae97a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};